import { useQuery } from 'react-query';

import { getSRBMTraps } from 'api/traps/SRBMTraps/getSRBMTraps';

export const useGetSRBMTraps = (
  slug: string,
  page: number,
  search?: string,
  ordering?: string,
  enabled: boolean = true,
) => {
  const { data, refetch, isLoading } = useQuery('srbmTraps', () => getSRBMTraps(slug, page, search, ordering), {
    refetchOnWindowFocus: false,
    enabled,
  });

  return { data, refetch, isLoading };
};

export default useGetSRBMTraps;
